//Library
import React, { useState, useEffect } from "react";

//Material
import { MuiHeader } from "../../stories/header2";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { BaseContainer } from "../../stories/base-container";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
//Component
//Function
import { GetListManual } from "./api";
import pdfImage from '../../assets/pdf.png';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    table: {
        minWidth: 900,
    },
}));

export const Manual = () => {
    const classes = useStyles();
    const [listManual, setListManual] = useState([]);
    const fetch = async () => {
        let res = await GetListManual();
        setListManual(res);
    }
    useEffect(() => {
        fetch();
    }, []);

    const onDownloadFile = async (pUrl) => {
        if (pUrl) {
            window.open(pUrl, '_blank');
        }
    }
    return (
 
            <BaseContainer maxWidth={false}>
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    //alignItems="center"
                    // justify="center"
                    style={{ minHeight: "80vh" }}
                >
                    <Grid item xs={12} >
                        <Container component="main" maxWidth="lg">
                            <Typography component="h1" variant="h3" paragraph align="center">
                                User Manual
                            </Typography>
                            <TableContainer component={Paper}>
                                <Table className={classes.table} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell align="center">User Manual</StyledTableCell>
                                            <StyledTableCell align="center">Download</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listManual.map((row) => (
                                            <StyledTableRow key={row.MANUAL_NO}>
                                                <StyledTableCell component="th" scope="row">
                                                    {row.MANUAL_NAME}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <Link
                                                        component="button"
                                                        variant="body2"
                                                        onClick={() => {
                                                            onDownloadFile(row.URL);
                                                        }}
                                                    >
                                                        <img src={pdfImage} alt="Click to download." width="50" height="50" />

                                                    </Link>


                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    </Grid>
                </Grid>
            </BaseContainer>
    );
};
export default Manual;